import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from '../../lib/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

export type CheckboxProps = ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
>;

/** Eine Checkbox die zwei Werte repräsentiert */
const Checkbox = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-[0.25rem] border-2 border-neutrals-N300 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutrals-N500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ',
      'data-[state=checked]:bg-primary-blue-B600 data-[state=checked]:text-white data-[state=checked]:border-0',
      'dark:data-[state=checked]:bg-primary-blue-B400',
      className,
    )}
    {...props}>
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}>
      <FontAwesomeIcon icon={faCheck} className="fa-xs h-3 w-3" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
